import { any } from 'prop-types'
import { object } from 'prop-types'
import React, { Fragment, useMemo } from 'react'
import { MarketingMatrixQuestionIsVisible } from '../../common/form/InputValidationHelper'
import QuestionSectionContent from '../../common/QuestionSectionContent'

const MarketingMatrixQuestion = ({ setFieldValue, question, values }) => {
  const showQuestion = useMemo(() => {
    return MarketingMatrixQuestionIsVisible(question, values)
  }, [question, values])

  return (
    <Fragment>
      {showQuestion && (
        <QuestionSectionContent
          values={values}
          showQuestion={showQuestion}
          setFieldValue={setFieldValue}
          key={question.id}
          question={question}
          isMarketingMatrix
        />
      )}
    </Fragment>
  )
}

MarketingMatrixQuestion.propTypes = {
  values: object,
  setFieldValue: any,
  question: object,
}

export default MarketingMatrixQuestion
